import { Repeat } from "lucide-react";

export type Recurrence = { type: "daily" | "weekly"; days: number[]; weeks: number; auto_renew: boolean } | null;
const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export function countVisits(dateIso: string, rec: Recurrence): number {
  if (!dateIso) return 0;
  if (!rec) return 1;
  const start = new Date(`${dateIso}T00:00:00`);
  const end = new Date(start); end.setDate(end.getDate() + rec.weeks * 7);
  let n = 0;
  for (const d = new Date(start); d < end && n < 60; d.setDate(d.getDate() + 1)) {
    const wd = (d.getDay() + 6) % 7;
    if (rec.type === "daily" || rec.days.includes(wd)) n++;
  }
  return n;
}

export function RecurrencePicker({ value, onChange }: { value: Recurrence; onChange: (r: Recurrence) => void }) {
  const mode = value ? value.type : "once";
  const set = (m: string) => onChange(m === "once" ? null : { type: m as "daily" | "weekly", days: value?.days?.length ? value.days : [0, 2, 4], weeks: value?.weeks || 4, auto_renew: value?.auto_renew || false });
  return (
    <div className="space-y-3 rounded-xl border border-brand-line bg-slate-50 p-3" data-testid="recurrence-picker">
      <div className="inline-flex w-full rounded-lg border border-brand-line bg-white p-1">
        {[["once", "One visit"], ["weekly", "Weekly"], ["daily", "Daily"]].map(([m, l]) => (
          <button key={m} type="button" onClick={() => set(m)} className={`flex-1 rounded-md py-1.5 text-xs font-semibold transition ${mode === m ? "bg-brand-navy text-white" : "text-brand-slate"}`} data-testid={`recurrence-${m}`}>{l}</button>
        ))}
      </div>
      {value && (
        <>
          {value.type === "weekly" && (
            <div className="flex flex-wrap gap-1.5" data-testid="recurrence-days">
              {DAYS.map((d, i) => <button key={d} type="button" onClick={() => onChange({ ...value, days: value.days.includes(i) ? value.days.filter((x) => x !== i) : [...value.days, i].sort() })} className={`rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${value.days.includes(i) ? "bg-brand-blue text-white ring-brand-blue" : "bg-white text-brand-slate ring-brand-line"}`} data-testid={`recurrence-day-${i}`}>{d}</button>)}
            </div>
          )}
          <label className="flex items-center justify-between text-xs text-brand-navy">For how many weeks?
            <select value={value.weeks} onChange={(e) => onChange({ ...value, weeks: Number(e.target.value) })} className="h-8 rounded-lg border border-brand-line bg-white px-2 text-xs" data-testid="recurrence-weeks">{[1, 2, 3, 4, 6, 8, 12].map((w) => <option key={w} value={w}>{w} week{w > 1 ? "s" : ""}</option>)}</select>
          </label>
          <label className="flex items-start gap-2 text-xs text-brand-navy"><input type="checkbox" checked={value.auto_renew} onChange={(e) => onChange({ ...value, auto_renew: e.target.checked })} className="mt-0.5" data-testid="recurrence-auto-renew" /><span><Repeat className="mr-1 inline h-3 w-3 text-brand-emerald" />Renew automatically — we'll securely save your card and book the next period 2 days before this one ends. Stop any time.</span></label>
        </>
      )}
    </div>
  );
}
